import { Box, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import {
  getSettlementRequestHistory,
  getSettlementRequestHistoryReportExcel,
} from "../../services/settlement.service";
import {
  GetSettlementRequestHistoryResponse,
  SettlmentRequestHistoryFilter,
} from "../../models/settlement.model";
import SettlementHistoryTable from "./components/SettlementHistoryTable";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/security.model";
import { getEnumsPersian } from "../../services/enum.services";
import { GetEnumsResponse } from "../../models/enum.model";
import SettlmentHistoryFilter from "./components/SettlmentHistoryFilter";
import TableFiltersSkeleton from "../../components/skeletons/TableFiltersSkeleton";

const SettlementHistory = () => {
  const [settlementHistoryList, setSettlmentHistoryList] = useState<
    GetSettlementRequestHistoryResponse[]
  >([]);
  const [filterObject, setFilterObject] = useState<
    SettlmentRequestHistoryFilter
  >();
  const [settlementTypes, setSettlementTypes] = useState<GetEnumsResponse[]>();
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    }
  );
  const [showFilter, setShowFilter] = useState(true);

  // handlers
  const handleExportExcel = () => {
    getSettlementRequestHistoryReportExcelMutate({
      ...filterObject,
    });
  };

  // service calls
  const { mutate: GetSettlementRequestHistory } = useMutation(
    getSettlementRequestHistory,
    {
      onSuccess: (
        data: ApiResultModel<GetSettlementRequestHistoryResponse[]>
      ) => {
        if (data) {
          setSettlmentHistoryList(data.data);
          setPageInfo(data.pageInfo);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: getEnumsPersianMutate, isLoading } = useMutation(
    getEnumsPersian,
    {
      onSuccess: (data: GetEnumsResponse[]) => {
        if (data) {
          setSettlementTypes(data);
        }
      },
      onError: () => {},
    }
  );

  const { mutate: getSettlementRequestHistoryReportExcelMutate } = useMutation(
    getSettlementRequestHistoryReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    getEnumsPersianMutate({
      enumNames: ["SettlementType"],
    });
  }, []);
  useEffect(() => {
    GetSettlementRequestHistory({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);

  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter &&
          (!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <SettlmentHistoryFilter
                settlementTypes={settlementTypes!}
                setFilterObject={setFilterObject}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableFiltersSkeleton />
            </span>
          ))}
        <Grid item xs={12}>
          <SettlementHistoryTable
            settlementHistoryList={settlementHistoryList}
            pageInfo={pageInfo}
            currentPaginationInfo={currentPaginationInfo}
            setCurrentPaginationInfo={setCurrentPaginationInfo}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SettlementHistory;
